import React from "react";
import PropTypes from "prop-types";
import { Card, CardContent } from "@mui/material";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
    containerWrapper: {
        backgroundColor: "#fff",
        padding: "0 20px 10px 20px",
    },
});

const CardContainer = ({ children }) => {
    const classes = useStyles();

    return (
        <Card className={classes.containerWrapper}>
            <CardContent>{children}</CardContent>
        </Card>
    );
};

CardContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.element])
        .isRequired,
};

export default CardContainer;
